import React, { Fragment } from "react";
import { Form, FormArray, FormConsumer } from "../Form";
import { TableBulkAction } from "../forms/formGrid/FormGridBulkAction";
import { FormGridInput } from "../forms/formGrid/FormGridInput";
import { useTranslation } from "../hooks/useTranslation";
import { OpacityOverlay } from "../OpacityOverlay";
import { FormStateStatus } from "../utils/FormStateStatus";
import { TableHead } from "./Table";
import { TableEmpty, TableWrapper, TD, TDAction } from "./TableComponents";
import { TableDropdown } from "./TableDropdown";
import { getCellId, getDataTestId, getItemNodeFormatting } from "./tableUtils";
export function TableForm(_a) {
    var _b;
    var form = _a.form, children = _a.children, id = _a.id, dataId = _a.dataId, dataTestId = _a.dataTestId, dataLabel = _a.dataLabel, view = _a.view;
    if (!form)
        return React.createElement(Fragment, null);
    var innerForm = (React.createElement("fieldset", null,
        React.createElement("legend", { className: "sr-only" }, form === null || form === void 0 ? void 0 : form.legend),
        React.createElement(FormStateStatus, { saveState: form.saveState, messages: form.messages }),
        React.createElement(OpacityOverlay, { on: form.saveState === "saving" },
            React.createElement(TableWrapper, { id: id, classNames: "table__form", dataId: dataId, dataTestId: dataTestId, dataLabel: dataLabel, view: view }, children))));
    if (!form.nestedForm)
        return React.createElement(Form, { values: (_b = form === null || form === void 0 ? void 0 : form.values) !== null && _b !== void 0 ? _b : {} }, innerForm);
    return innerForm;
}
export function TableHeadForm(_a) {
    var headings = _a.headings, endRowColumn = _a.endRowColumn, form = _a.form, loading = _a.loading;
    var typedForm = form;
    var values = typedForm.values, name = typedForm.name;
    return (React.createElement(TableHead, { headings: headings, data: [{}], endRowColumn: endRowColumn, form: form, loading: loading, tableHasData: values[name].length > 0 }));
}
export function TableBodyForm(_a) {
    var headings = _a.headings, noDataText = _a.noDataText, dropdown = _a.dropdown, id = _a.id, form = _a.form, loading = _a.loading, actions = _a.actions;
    var t = useTranslation();
    var columnNumbers = headings.length + (dropdown ? 1 : 0);
    if (!form) {
        return React.createElement(TableEmpty, { text: noDataText, columnNumbers: columnNumbers });
    }
    if (loading) {
        return (React.createElement(TableEmpty, { text: "".concat(t("Loading"), "..."), columnNumbers: columnNumbers }));
    }
    var typedForm = form;
    var values = typedForm.values, name = typedForm.name;
    var tableHasData = values[name].length > 0;
    if (!tableHasData) {
        return React.createElement(TableEmpty, { text: noDataText, columnNumbers: columnNumbers });
    }
    var showBulkAction = headings.some(function (heading) { var _a; return (_a = heading.formComponent) === null || _a === void 0 ? void 0 : _a.bulkAction; });
    return (React.createElement("tbody", null,
        form.viewState === "edit" && showBulkAction && (React.createElement(TableBulkAction, { headings: headings, dropdown: dropdown, form: form })),
        React.createElement(FormArray, { name: name },
            React.createElement(FormConsumer, null, function (_a) {
                var values = _a.values, errors = _a.errors, arrayIndex = _a.arrayIndex;
                return (React.createElement("tr", null,
                    headings.map(function (heading, i) { return (React.createElement(TD, { cellId: getCellId(id, arrayIndex), hiddenBreakpoints: heading.hiddenBreakpoints, key: i, width: heading.width, dataTestId: getDataTestId(heading, arrayIndex) }, heading.formComponent ? (React.createElement(FormGridInput, { column: heading.formComponent, labelHidden: true, viewState: form.viewState, rowId: arrayIndex })) : (getItemNodeFormatting(heading, values)))); }),
                    form.viewState === "read" && dropdown && dropdown.length && (React.createElement(TDAction, { dataId: actions === null || actions === void 0 ? void 0 : actions.dataId, dataLabel: actions === null || actions === void 0 ? void 0 : actions.dataLabel, dataTestId: actions === null || actions === void 0 ? void 0 : actions.dataTestId, rowId: arrayIndex },
                        React.createElement(TableDropdown, { key: "actions", item: values, dropdown: dropdown, tableId: id, rowId: arrayIndex })))));
            }))));
}
